enum DynamicParametersType {
  Text = 0,
  Color = 1,
  FloatNumber = 3,
  Image = 4,
  Video = 6,
  Boolean = 7,
  Selector = 8,
  Audio = 9,
  Link = 10,
  Widget = 11,
  Font = 12,
  QR = 13,
  Subtitles = 14,
}

enum DPMappingResizeOption {
  Contain = 3,
  Cover = 4,
  NoResize = 5,
}

enum DPMappingVerticalAlign {
  Top = 0,
  Center = 1,
  Bottom = 2,
}

enum DPMappingHorizontalAlign {
  Left = 'Left',
  Right = 'Right',
  Center = 'Center',
}

enum SourceLayerType {
  Text = 0,
  Solid = 1,
  Null = 2,
  Shape = 3,
  Video = 4,
  Audio = 5,
  Image = 6,
  Camera = 7,
  Precomp = 8,
}

enum SourceLayerParam {
  FillColor = 'Fill Color',
  StrokeColor = 'Stroke Color',
  FontSize = 'Font Size',
  ImageSource = 'Image',
  VideoSource = 'Video',
  AudioSource = 'Audio',
  Alt = 'Alt Text',
  TextSource = 'Text',
  HTMLContent = 'HTML Content',
  Click = 'Link',
  ColorOverlay = 'Color Overlay',
  Condition = 'Condition',
  Font = 'Font',
  Widget = 'Widget',
  QR = 'QR Code',
  Subtitles = 'Subtitles',
}

enum DPDynamicSourceTypeName {
  Product = 'product',
  Location = 'location',
  Content = 'content',
  Weather = 'weather',
  General = 'general',
  Campaign = 'campaign',
}

enum DPDynamicSourceType {
  Product = 0,
  Location = 1,
  Weather = 2,
  General = 3,
  Content = 4,
  Campaign = 11,
}

enum TemplateAssetType {
  Image = 'Image',
  Video = 'Video',
  Font = 'Font',
  Layer = 'Layer',
  LayerGroup = 'LayerGroup',
  Subtitles = 'Subtitle',
}

export {
  DynamicParametersType,
  DPMappingResizeOption,
  SourceLayerType,
  SourceLayerParam,
  DPDynamicSourceType,
  DPDynamicSourceTypeName,
  DPMappingVerticalAlign,
  DPMappingHorizontalAlign,
  TemplateAssetType,
};
